// used on details & video gallery pages
$(function () {

	//initialize scroller
	function InitScroller() {
		$(".Scroller").slick({ 		
			dots: false,
			infinite: false,
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 5,
			responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4
				}
			},
			{
				breakpoint: 700,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			}]
		 });    
	
		$(".Scroller img").lazyload({
			threshold: 0,
			effect: "fadeIn",
			data_attribute: "lazy",
			failure_limit: 60
		});	
	}

	//initialize tabs
	function InitTabs() {
		var panelWidth;
		$("#tabs").tabs({
			active: 0,
			create: function (event, ui) {
				var tabNumber = $(".ui-tabs-nav li").length;
				$(".ui-tabs-nav li").width((100/tabNumber)+"%");
				$("#tabs").css("visibility", "visible");
				panelWidth = $("#tabs").width() > 0 ? $("#tabs").width() - 25 : panelWidth;
				//$(".ui-tabs-nav li").attr("tabindex", "0");
			},
			activate: function (event, ui) {
				var scroller = ui.newPanel.find(".Scroller");
				scroller[0].slick.setPosition(); 
				scroller.width(100+"%");			 
		      }
		});
	}
	
	try 
	{
		InitTabs();	
	} 
	catch(e) {
		//jQuery is throwing a malformed uri exception on some url's
		//this catch will disable similar, faster, lower min.. etc tabs at the bottom of details page
		$('#tabs').addClass('hide');
	}
	
	InitScroller(); 
	
	//$(".ui-tabs-nav li").keydown(function(ev) {
	//	if (ev.which ==13) {
	//		$(this).click()
	//	}
	//});
	
	//***This is how you can load a scroller via ajax***//
	//var url = ui.newTab.context.attributes["data-url"].value;
	//LoadProductsAjax(url, ui.newPanel, true);
	function LoadProductsAjax(url, container, blockui) {
		if (blockui) {
			container.block({
				message: "<img src='//cdna.4imprint.ie/qtz/core/loadingCircle2016.gif' alt='' />", overlayCSS: {
					backgroundColor: '#fff',
					opacity: 0.9,
					cursor: 'wait'
				}
			});
			setTimeout(function () {
				$.ajax({
					type: "POST",
					url: url,
					dataType: "html",
					timeout: 15000,
					success: function (result) {
						container.html(result);
						InitScroller();
		                    	container.unblock();
					},
					error: function (result) {
						container.unblock();
					}
				});
			}, 300);
		}
		else {
			$.ajax({
				type: "POST",
				url: url,
				dataType: "html",
				timeout: 15000,
				success: function (result) {
					container.html(result);
					InitScroller();
		                 container.unblock(); 
				}
			});
		}
	}
});